import type { FormControl } from '@angular/forms';
import type { ServiceOffering } from '@freelancer/datastore/collections';
import { AvailedAiServiceEnum } from '@freelancer/datastore/collections';
import type { ServiceType } from '../ai-services/ai-services.types';

export interface AiServiceConsultationModalData {
  retellAiAgentId: string;
  serviceOffering: ServiceOffering;
  serviceType: ServiceType;
}

export interface AiServiceConsultationDetailsForm {
  country: FormControl<string>;
  phoneNumber: FormControl<string>;
  name: FormControl<string>;
}

// Kept consistent with our Security Phone Input in User Settings
export const PHONE_NUMBER_MAX_LENGTH = 16;

export const AI_SERVICE_OFFERING_TO_AVAILED_AI_SERVICE_ENUM = {
  'artificial_intelligence/ai-action-plan': AvailedAiServiceEnum.ACTION_PLAN,
  'artificial_intelligence/ai-lead-generator':
    AvailedAiServiceEnum.LEAD_GENERATOR,
  'artificial_intelligence/ai-appointment-setter':
    AvailedAiServiceEnum.APPOINTMENT_SETTER,
  'artificial_intelligence/ai-support-agent':
    AvailedAiServiceEnum.SUPPORT_AGENT,
  'artificial_intelligence/ai-call-center': AvailedAiServiceEnum.CALL_CENTER,
};
